import { Checkbox, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const StoreGroups = ({ store, showName, selectedGroupIds, fixedGroupIds, onToggleGroup }) => {
  return (
    <Styles.Container>
      {showName && <Text type="titleXS">{store.name}</Text>}
      <Styles.Grid>
        {store.groups.map(group => (
          <Checkbox
            key={group.id}
            label={group.name}
            checked={selectedGroupIds.includes(group.id)}
            disabled={fixedGroupIds.includes(group.id)}
            onChange={() => onToggleGroup(group.id)}
          />
        ))}
      </Styles.Grid>
    </Styles.Container>
  )
}

export default StoreGroups
